var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOracleCorporationLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_26022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0892 26.0885C4.48408 26.0885 0 21.6044 0 15.9993C0 10.3942 4.48408 5.91016 10.0892 5.91016H21.9108C27.5159 5.91016 32 10.3942 32 15.9993C32 21.6044 27.5159 26.0885 21.9108 26.0885H10.0892ZM21.6051 22.5216C25.2739 22.5216 28.1274 19.5662 28.1274 15.9993C28.1274 12.3305 25.172 9.47704 21.6051 9.47704H10.3949C6.72611 9.47704 3.87261 12.4324 3.87261 15.9993C3.87261 19.5662 6.82803 22.5216 10.3949 22.5216H21.6051Z",
    fill: "#C74634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_26022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleCorporationLogo1);
export default __webpack_public_path__ + "static/media/oracle-corporation-logo 1.68543c194bfdf5fdbffca18aa7b47bf8.svg";
export { ForwardRef as ReactComponent };